export { couponResponseAdapter, getCouponDetailResponseAdapter } from './coupon-res.adapter'
